import React from 'react'
import styled from 'styled-components'

/**
 * 画面ごとのコンテンツ表示エリア
 */
const ContentArea: React.FC<ContentAreaProps> = (props) => {
  return (
    <React.Fragment>
      {props.content && <StyledContentArea>{props.content}</StyledContentArea>}
    </React.Fragment>
  )
}

export type ContentAreaProps = {
  content?: React.ReactNode
}

const StyledContentArea = styled.div`
  margin: 32px 8px;
`

export default ContentArea
